import { createContext } from "react";
import { useProvideSessionInProgress } from "./useProvideSessionInProgress";

export type SessionInProgressContextValue = ReturnType<typeof useProvideSessionInProgress>;

const SessionInProgressContext = createContext<SessionInProgressContextValue>({} as SessionInProgressContextValue);

export { SessionInProgressContext };